/**
 * Editorial section kicker used across the site.
 *
 * Style: small uppercase text with wide letter-spacing, prefixed by a
 * thin vertical rule. Tone-adaptive for use on both light and dark
 * surfaces. No pill background — clean, sophisticated, standard.
 *
 * Props:
 *  - label: uppercase text
 *  - tone:  "dark" (default, use on light bg) or "light" (use on dark bg)
 *  - icon:  optional lucide icon; kept for API compatibility, ignored
 *           by the new design so all sections read the same
 *  - innerBg: legacy prop, ignored
 */
export default function SectionBadge({ label, tone = "dark" }) {
  const isDark = tone === "dark";
  const textCls = isDark ? "text-zinc-700" : "text-white/70";
  const ruleCls = isDark ? "bg-black/60" : "bg-white/60";

  return (
    <div
      data-testid={`section-badge-${label.toLowerCase().replace(/\s+/g, "-")}`}
      className="inline-flex items-center gap-3"
    >
      <span className={`inline-block h-px w-10 ${ruleCls}`} aria-hidden />
      <span
        className={`text-[11px] font-semibold tracking-[0.32em] uppercase ${textCls}`}
      >
        {label}
      </span>
    </div>
  );
}
